/**
 * Created by xupengwei on 2018/6/26.
 * Modified by heyushuang on 2019/9/26.
 */
export default {
  showDarkMask(state) {
    state.dataDarkMask = true;
  },
  hideDarkMask(state) {
    state.dataDarkMask = false;
  },
  showTransMask(state) {
    state.dataTransMask = true;
  },
  hideTransMask(state) {
    state.dataTransMask = false;
  },
  showClickDarkMask(state, payload) {
    state.clickDarkMask = true;
    if (payload.callbackFunc) {
      state.clickDarkMaskCallbackFunc = payload.callbackFunc;
    } else {
      state.clickDarkMaskCallbackFunc = null;
    }
  },
  hideClickDarkMask(state) {
    state.clickDarkMask = false;
  },
  showClickTransMask(state, payload) {
    state.clickTransMask = true;
    if (payload.callbackFunc) {
      state.clickTransMaskCallbackFunc = payload.callbackFunc;
    } else {
      state.clickTransMaskCallbackFunc = null;
    }
  },
  hideClickTransMask(state) {
    state.clickTransMask = false;
  },
  showLoading(state) {
    // console.log('showLoading');
    this.commit('showDarkMask');
    state.dataLoading = true;
    // console.log(state);
  },
  hideLoading(state) {
    // console.log('hideLoading');
    this.commit('hideDarkMask');
    state.dataLoading = false;
  },
  showOpenGLoading(state) {
    this.commit('showLoading');
    state.openGLoading = true;
  },
  hideOpenGLoading(state) {
    this.commit('hideLoading');
    state.openGLoading = false;
  },
  showMsg(state, msg) {
    this.commit('hideLoading');
    state.msgBoxContent = msg;
    state.dataMsgBox = true;
  },
  showMsgAutoclose(state, payload) {
    // console.log('showMsgAutoclose');
    this.commit('hideLoading');

    state.msgBoxContent = payload.msg;
    if ('white'==payload.bg) {
      this.commit('showDarkMask');
      state.dataWhiteMsgBox = true;
    } else {
      this.commit('showTransMask');
      state.dataMsgBox = true;
    }
    // console.log('setTimeout:'+String(payload.microsec?payload.microsec:3000));
    setTimeout(() => {
      this.commit('hideMsg');
      this.commit('hideTransMask');
      this.commit('hideDarkMask');
      if (payload.callbackFunc) {
        payload.callbackFunc();
      }
    }, payload.microsec?payload.microsec:3000);
  },
  hideMsg(state) {
    state.dataMsgBox = false;
    state.dataWhiteMsgBox = false;
    state.msgBoxContent = '';
  },
  checkApiHandler(state, data) {
    if (data.code == 0) {
      return;
    }
    this.commit('showMsgAutoclose', {'msg': 'error: '+data.code_msg+'('+ data.code+')'});
  },
  setTitle(state, payload) {
    // console.log('setTitle');
    // console.log(payload);
    state.titleObj.currentTitle = payload.text;
    if (payload.showRightBtn) {
      state.titleObj.showRightBtn = true;
      state.titleObj.rightText = payload.rightText;
      state.titleObj.rightFun = payload.rightFun;
    } else {
      state.titleObj.showRightBtn = false;
    }
    if (payload.hasLCallbackFunc) {
      state.titleObj.hasLCallbackFunc = true;
      state.titleObj.leftFun = payload.leftFun;
    } else {
      state.titleObj.hasLCallbackFunc = false;
      state.titleObj.leftFun = null;
    }
    // console.log(state.titleObj);
  },
  setLocation(state, location) {
    state.garageInfoObj.installLocation = Number(location);
  },
  setConnectMethod(state, mSelected) {
    state.garageInfoObj.connectMethod = Number(mSelected);
  },
  setMotorModel(state, payload) {
    // console.log(payload);
    state.garageInfoObj.motorFactroy = payload.motorFactroy;
    state.garageInfoObj.motorModel = payload.motorModel;
  }
};




// WEBPACK FOOTER //
// ./src/store/mutations.js